// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Avatar, Deposit, NewUser as User } from '../../assets/svg';
import {
  USER_INFO_DEPOSIT_BTN_WIDTH,
  USER_INFO_AVATAR_BTN_WIDTH,
  USER_INFO_USER_BUTTON_MARGIN_RIGHT,
} from '../../constants/ui/userInfo';
import UserBankrollContainer from '../UserBankroll/UserBankrollContainer';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
`;

const commonBlock = css`
  display: flex;
  justify-content: center;
  align-items: stretch;
  max-height: 3em;
`;

const UserIcon = styled(User)`
  width: 1em;
  min-width: 1em;
  color: #fff;
  margin: 0 0.3em;
`;

const DepositButton = styled(Deposit)`
  position: relative;
  width: ${USER_INFO_DEPOSIT_BTN_WIDTH}em;
  height: 90%;

  transition: transform 100ms ease-in-out;

  &:active {
    transform: scale(0.95);
  }
`;

const UserButton = styled.div`
  ${commonBlock}
  outline: none;
  margin-right: ${USER_INFO_USER_BUTTON_MARGIN_RIGHT}em;
  height: 90%;
  transition: transform 100ms ease-in-out;
  max-width: calc(100% - ${USER_INFO_DEPOSIT_BTN_WIDTH}em - ${USER_INFO_USER_BUTTON_MARGIN_RIGHT}em);
  &:active {
    transform: scale(0.95);
  }
`;

const UserAvatar = styled(Avatar)`
  width: ${USER_INFO_AVATAR_BTN_WIDTH}em;
`;

type PropsType = {
  onUserClick: () => void;
  onDepositButtonClick: () => void;
  className?: string;
};

const UserInfo = ({ onUserClick, onDepositButtonClick, className }: PropsType) => {
  return (
    <Wrapper className={className}>
      <DepositButton onClick={onDepositButtonClick} />

      <UserButton onClick={onUserClick}>
        <UserBankrollContainer />
        <UserAvatar>
          <UserIcon />
        </UserAvatar>
      </UserButton>
    </Wrapper>
  );
};

export default UserInfo;
